// Copied from https://github.com/stklcode/chartist-plugin-tooltip/blob/main/src/scripts/chartist-plugin-tooltip.ts

import * as Chartist from 'chartist';
import { BarChart, BaseChart, PieChart } from 'chartist';

export function ChartistPluginTooltip(chart, options) {
    const defaultOptions = {
        tooltipOffset: {
            x: 0,
            y: -20
        },
        anchorToPoint: false,
        appendToBody: true,
        class: undefined,
        pointClass: 'ct-point',
        tooltipFnc: undefined,
        transformTooltipTextFnc: undefined,
        metaIsHTML: false
    };

    const $options = Chartist.extend({}, defaultOptions, options);

    let tooltipSelector = $options.pointClass;

    if (!options?.pointClass) {
        if (chart instanceof BarChart) {
            tooltipSelector = 'ct-bar';
        } else if (chart instanceof PieChart) {
            if (chart.options.donut) {
                tooltipSelector = 'ct-slice-donut';
            } else {
                tooltipSelector = 'ct-slice-pie';
            }
        }
    }

    const $chart = chart.container;
    let $toolTipIsShown = false;
    let $tooltipOffsetParent = $chart.offsetParent || $chart;
    let $toolTip;

    {
        let tt;
        if (!$options.appendToBody) {
            tt = $chart.querySelector('.chartist-tooltip');
        } else {
            tt = document.querySelector('.chartist-tooltip');
        }

        if (!tt) {
            tt = document.createElement('div');
            tt.classList.add('chartist-tooltip');
            if ($options.class) {
                if (Array.isArray($options.class)) {
                    $options.class.forEach(c => tt.classList.add(c));
                } else {
                    tt.classList.add($options.class);
                }
            }
            if ($options.appendToBody) {
                document.body.appendChild(tt);
            } else {
                $chart.appendChild(tt);
            }
        }

        $toolTip = tt;
    }

    let height = $toolTip.offsetHeight;
    let width = $toolTip.offsetWidth;

    hide($toolTip);

    $chart.addEventListener('mouseover', event => {
        if (!event.target.classList.contains(tooltipSelector)) {
            return;
        }

        const $point = event.target;
        let tooltipText = '';

        let seriesName = '';
        if (chart instanceof Chartist.PieChart) {
            seriesName =
                $point.parentNode.getAttribute('ct:meta') ||
                $point.parentNode.getAttribute('ct:series-name') ||
                '';
        }
        let meta = $point.getAttribute('ct:meta') || seriesName || '';
        const hasMeta = !!meta;
        let value = $point.getAttribute('ct:value') || '';

        if (
            $options.transformTooltipTextFnc &&
            typeof $options.transformTooltipTextFnc === 'function'
        ) {
            value = $options.transformTooltipTextFnc(value);
        }

        if ($options.tooltipFnc && typeof $options.tooltipFnc === 'function') {
            tooltipText = $options.tooltipFnc(meta, value);
        } else {
            if ($options.metaIsHTML) {
                const txt = document.createElement('textarea');
                txt.innerHTML = meta;
                meta = txt.value;
            }

            meta = '<span class="chartist-tooltip-meta">' + meta + '</span>';

            if (hasMeta) {
                tooltipText += meta + '<br>';
            } else {
                if (chart instanceof Chartist.PieChart) {
                    const label = next($point, 'ct-label');
                    if (label) {
                        tooltipText += text(label) + '<br>';
                    }
                }
            }

            if (value) {
                value = '<span class="chartist-tooltip-value">' + value + '</span>';
                tooltipText += value;
            }
        }

        if ($toolTip && tooltipText) {
            $toolTip.innerHTML = tooltipText;

            height = $toolTip.offsetHeight;
            width = $toolTip.offsetWidth;

            if (!$options.appendToBody) {
                $tooltipOffsetParent = $chart.offsetParent || $chart;
            }
            if ($toolTip.style.display !== 'absolute') {
                $toolTip.style.display = 'absolute';
            }
            setPosition(event);
            show($toolTip);

            height = $toolTip.offsetHeight;
            width = $toolTip.offsetWidth;
        }
    });

    $chart.addEventListener('mouseout', event => {
        if (event.target.classList.contains(tooltipSelector)) {
            $toolTip && hide($toolTip);
        }
    });

    $chart.addEventListener('mousemove', event => {
        if (!$options.anchorToPoint && $toolTipIsShown) {
            setPosition(event);
        }
    });

    function setPosition(event) {
        height = height || $toolTip.offsetHeight;
        width = width || $toolTip.offsetWidth;
        const offsetX = -width / 2 + $options.tooltipOffset.x;
        const offsetY = -height + $options.tooltipOffset.y;

        const anchor =
            $options.anchorToPoint &&
            event.target &&
            event.target.x2 &&
            event.target.y2;

        if ($options.appendToBody) {
            if (anchor) {
                const box = $chart.getBoundingClientRect();
                const left =
                    event.target.x2.baseVal.value + box.left + window.scrollX;
                const top =
                    event.target.y2.baseVal.value + box.top + window.scrollY;

                $toolTip.style.left = left + offsetX + 'px';
                $toolTip.style.top = top + offsetY + 'px';
            } else {
                $toolTip.style.left = event.pageX + offsetX + 'px';
                $toolTip.style.top = event.pageY + offsetY + 'px';
            }
        } else {
            const offsetBox = $tooltipOffsetParent.getBoundingClientRect();
            const allOffsetLeft = -offsetBox.left - window.scrollX + offsetX;
            const allOffsetTop = -offsetBox.top - window.scrollY + offsetY;

            if (anchor) {
                const box = $chart.getBoundingClientRect();
                const left =
                    event.target.x2.baseVal.value + box.left + window.scrollX;
                const top =
                    event.target.y2.baseVal.value + box.top + window.scrollY;

                $toolTip.style.left = left + allOffsetLeft + 'px';
                $toolTip.style.top = top + allOffsetTop + 'px';
            } else {
                $toolTip.style.left = event.pageX + allOffsetLeft + 'px';
                $toolTip.style.top = event.pageY + allOffsetTop + 'px';
            }
        }
    }

    function show(element) {
        $toolTipIsShown = true;
        element.classList.add('tooltip-show');
    }

    function hide(element) {
        $toolTipIsShown = false;
        element.classList.remove('tooltip-show');
    }

    function next(element, className) {
        let nextEl = element;
        do {
            nextEl = element.nextSibling;
        } while (nextEl && !nextEl.classList.contains(className));

        return nextEl;
    }

    function text(element) {
        return element.innerText || element.textContent || '';
    }
}
